<template>
<div class="main_banner">
    <img :src="mainImgOnload" v-show="onload">
    <!-- <img :src="`${$store.state.dir}images/main.png`"> -->
    <!--
     <dl>
        <dt>
            모바일 쇼룸<br>
            상담예약 서비스
        </dt>
        <dd>
            <button @click="$router.replace('/brandList')">Reservation<i class="far fa-long-arrow-alt-right"></i></button>
        </dd>
    </dl> 
    -->
</div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'MainBanner',

    data() {
        return {
            mainImgOnload: '',
            mainImg: '',
        }
    },
    computed: {
        ...mapState({
            imgSampleMainBanner: state => state.resource.imgSampleMainBanner,
            BANNER_DTYPE_MAIN_ID: state => state.codeDictionary.items.BANNER_DTYPE.MAIN.id,
            onload: state => state.common.onload,
        }),
    },
    watch: {
        onload(val) {
            if(val) {
                this.mainImgOnload = this.mainImg;
            }
        }
    },
    created () {
    },

    methods: {
        getMainImg() {
            let filters = {
                type: this.BANNER_DTYPE_MAIN_ID,
                size: 1,
                sort: 'id,desc',
            };

            this.$store.dispatch('GET_BANNER_LIST', filters)
            .then((data)=>{
                if(data.content.length > 0) 
                    this.mainImg = data.content[0].bannerUrl;
                else
                    this.mainImg = this.imgSampleMainBanner
            })
            .catch(()=> {
                this.mainImg = this.imgSampleMainBanner
            })
        },
    },
}
</script>

<style lang="scss" scoped>

</style>